function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Immutable from 'seamless-immutable';
import { stateGo } from 'redux-ui-router';
import partial from 'ramda/src/partial';
import __ from 'ramda/src/__';
import i18n from 'invision-core/src/components/i18n/i18n';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import MetadataSelectors from 'invision-core/src/components/metadata/metadata.selectors';
import MetadataActions from 'invision-core/src/components/metadata/metadata.actions';
import { fetchCodeTypes } from 'invision-core/src/components/metadata/codes/codes.actions';
import { MetadataCodeLoadedSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { PageSizePreferenceSelector } from 'invision-core/src/components/session/session.selectors';
import CustomerLocaleKeys from '../../../../../locales/keys';
import { CurrentCustomerIdSelector, CurrentCustomerSelector, RouteParams } from '../../../../../reducers/selectors/customer.selectors';
import { ActiveServicesSelector, BulkServicesCurrentPageCountSelector, BulkServicesCurrentPageNumberSelector, BulkServicesPageNumberSelector, BulkServicesPageSizeSelector, BulkServicesRecordCountSelector, BulkServicesSearchErrorSelector, BulkServicesSearchStringSelector, BulkServicesStatusesSelector, BulkServicesTableDataSelector, HasSuspendResumePermissionSelector, IncludeStatusFilterSelector, IncludeTypeOfServiceFilterSelector, IsFetchingBulkServices, IsServiceLifeCycleStatusUpdatableSelector, ServicesTypeSelector, ServicesWithFormattedServiceAttributeSelector } from '../../../../../reducers/selectors/services.selectors';
import { handleMoreOptionSelected, navigateToNonTelcoUsageDetails, navigateToUsageDetails, navigateToView, SERVICES_MORE_OPTIONS_CONSTANTS } from './services.list.controller.helper';
import { searchServices, setBulkServicesPageSize, setBulkServicesSearchString, setBulkServicesStatusFilter, setCurrentPage, setServicesTypeOfServiceFilter } from '../../../../../reducers/actions/services.actions';
import { ORDER_STATUS, ORDER_TYPES } from '../../../orderHistory/orderDetails/order.details.constants';
import { searchOrders } from '../../../../../reducers/actions/order.history.actions';
import { createTableServicesListHeaders, DEFAULT_PAGE_NUMBER, TYPE_OF_SERVICE, NON_BULK_SERVICE_CATEGORIZATION } from './services.list.constants';
import { retrieveConvergentBillerAccountDetails } from '../../../../../reducers/actions/customer.convergent.biller.actions';
import { SERVICE_DETAILS_STATE_NAME } from '../../services.and.usage.config';
var ServicesListController = /*#__PURE__*/function () {
  function ServicesListController($ngRedux, $log, $scope, $timeout, uiNotificationService) {
    _classCallCheck(this, ServicesListController);
    Object.assign(this, {
      $log: $log,
      $ngRedux: $ngRedux,
      $scope: $scope,
      $timeout: $timeout,
      cellTypesOfService: _defineProperty(_defineProperty({}, TYPE_OF_SERVICE.BULK, i18n.translate(CustomerLocaleKeys.SERVICES_LIST.TYPES.BULK)), TYPE_OF_SERVICE.NON_BULK, i18n.translate(CustomerLocaleKeys.SERVICES_LIST.TYPES.NON_BULK)),
      CustomerLocaleKeys: CustomerLocaleKeys,
      handleTypeOfServiceFilter: this.handleTypeOfServiceFilter.bind(this),
      SERVICE_DETAILS_STATE_NAME: SERVICE_DETAILS_STATE_NAME,
      typeOfServiceText: i18n.translate(CustomerLocaleKeys.SERVICES_LIST.TYPE_OF_SERVICE),
      uiNotificationService: uiNotificationService
    });
  }
  return _createClass(ServicesListController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this,
        _this$moreCellOptions;
      var codeTables = [CODES.FeatureToggleConfig, CODES.RegularExpression, CODES.ServiceAttribute, CODES.ServiceLifeCycleStatus, CODES.UnitsOfMeasure];
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          activeServices: ActiveServicesSelector(store),
          attributeConfiguration: MetadataSelectors.codes.MetadataCodeTypeSelector(CODES.ServiceAttribute, store),
          bulkServices: ServicesWithFormattedServiceAttributeSelector(store),
          bulkServicesError: BulkServicesSearchErrorSelector(store),
          currentCustomer: CurrentCustomerSelector(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          currentPageNumber: BulkServicesCurrentPageNumberSelector(store),
          hasSuspendResumeAccess: HasSuspendResumePermissionSelector(store),
          isCodeTableLoaded: MetadataCodeLoadedSelector(__, store),
          isFetchingBulkServices: IsFetchingBulkServices(store),
          isServiceLifeCycleStatusLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(CODES.ServiceLifeCycleStatus, store),
          isServiceLifeCycleStatusUpdatable: IsServiceLifeCycleStatusUpdatableSelector(store),
          isServiceReasonCodeLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(CODES.ReasonCodes, store),
          isUnitOfMeasurementLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(CODES.UnitsOfMeasure, store),
          pageCount: BulkServicesCurrentPageCountSelector(store),
          pageNumber: BulkServicesPageNumberSelector(store),
          pageSize: BulkServicesPageSizeSelector(store),
          recordCount: BulkServicesRecordCountSelector(store),
          regexCodesLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(CODES.RegularExpression, store),
          regexCodes: MetadataSelectors.codes.MetadataCodeTypeSelector(CODES.RegularExpression, store),
          routeParams: RouteParams(store),
          searchString: BulkServicesSearchStringSelector(store),
          selectedStatusFilter: IncludeStatusFilterSelector(store),
          selectedTypeOfServiceFilter: IncludeTypeOfServiceFilterSelector(store),
          serviceAttributesLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(CODES.ServiceAttribute, store),
          statusCodes: BulkServicesStatusesSelector(store),
          tableData: BulkServicesTableDataSelector(store),
          typesOfServiceCodes: ServicesTypeSelector(store),
          userPageSizePreference: PageSizePreferenceSelector(store)
        };
      };
      var controllerActions = {
        fetchCodeTypes: fetchCodeTypes,
        fetchCodeTypesThunk: MetadataActions.codes.fetchCodeTypesThunk,
        fetchRegexCodes: function fetchRegexCodes() {
          return MetadataActions.codes.fetchCodeTypes(CODES.RegularExpression);
        },
        fetchServiceAttributes: MetadataActions.codes.fetchServiceAttributes,
        retrieveConvergentBillerAccountDetails: retrieveConvergentBillerAccountDetails,
        searchOrders: searchOrders,
        searchServices: searchServices,
        setBulkServicesPageSize: setBulkServicesPageSize,
        setBulkServicesSearchString: setBulkServicesSearchString,
        setBulkServicesStatusFilter: setBulkServicesStatusFilter,
        setCurrentPage: setCurrentPage,
        setServicesTypeOfServiceFilter: setServicesTypeOfServiceFilter,
        stateGo: stateGo
      };
      this.disconnect = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
        _this.grid ? _this.grid.data = _this.state.tableData : null;
      });
      codeTables.forEach(function (code) {
        if (!_this.state.isCodeTableLoaded(code)) {
          _this.actions.fetchCodeTypesThunk(code).catch(_this.onApiError);
        }
      });
      this.grid = this.servicesGridSetup();
      this.navigateToView = partial(navigateToView, [this.$ngRedux]);
      this.handleMoreOptionSelected = partial(handleMoreOptionSelected, [this.$scope, this.$log, this.$ngRedux, this.state.routeParams]).bind(this);
      this.navigateToUsageDetails = partial(navigateToUsageDetails, [this.state.routeParams]).bind(this);
      this.navigateToNonTelcoUsageDetails = partial(navigateToNonTelcoUsageDetails, [this.state.routeParams]).bind(this);

      //MoreMenuItems Map object
      this.moreCellOptions = [{
        id: SERVICES_MORE_OPTIONS_CONSTANTS.VIEW_SERVICE_DETAILS,
        title: i18n.translate(CustomerLocaleKeys.VIEW_SERVICE_DETAILS)
      }, {
        id: SERVICES_MORE_OPTIONS_CONSTANTS.VIEW_SERVICE_ATTRIBUTES,
        title: i18n.translate(CustomerLocaleKeys.ORDER_DETAILS.VIEW_SERVICE_ATTRIBUTES)
      }];
      this.moreCellOptionsForNonBulkActive = [{
        id: SERVICES_MORE_OPTIONS_CONSTANTS.VIEW_USAGE_CAPS,
        title: i18n.translate(CustomerLocaleKeys.USAGE_CAP_SETTINGS)
      }];
      this.moreCellOptionsForNonBulkActiveWithManageFeatures = [{
        id: SERVICES_MORE_OPTIONS_CONSTANTS.VIEW_USAGE_CAPS,
        title: i18n.translate(CustomerLocaleKeys.USAGE_CAP_SETTINGS)
      }, {
        id: SERVICES_MORE_OPTIONS_CONSTANTS.VIEW_MANAGE_FEATURES,
        title: i18n.translate(CustomerLocaleKeys.MANAGE_ADD_ONS)
      }];
      this.moreCellOptionsForNonBulkActiveLocked = [{
        id: SERVICES_MORE_OPTIONS_CONSTANTS.VIEW_USAGE_CAPS,
        title: i18n.translate(CustomerLocaleKeys.USAGE_CAP_SETTINGS)
      }];
      this.moreCellOptionsForNonBulkActiveLockedWithManageFeatures = [{
        id: SERVICES_MORE_OPTIONS_CONSTANTS.VIEW_USAGE_CAPS,
        title: i18n.translate(CustomerLocaleKeys.USAGE_CAP_SETTINGS)
      }, {
        id: SERVICES_MORE_OPTIONS_CONSTANTS.VIEW_MANAGE_FEATURES,
        title: i18n.translate(CustomerLocaleKeys.MANAGE_ADD_ONS)
      }];
      this.moreCellOptionsForNonBulkSuspended = [{
        id: SERVICES_MORE_OPTIONS_CONSTANTS.VIEW_USAGE_CAPS,
        title: i18n.translate(CustomerLocaleKeys.USAGE_CAP_SETTINGS)
      }];
      this.moreCellOptionsForNonBulkSuspendedWithManageFeatures = [{
        id: SERVICES_MORE_OPTIONS_CONSTANTS.VIEW_USAGE_CAPS,
        title: i18n.translate(CustomerLocaleKeys.USAGE_CAP_SETTINGS)
      }, {
        id: SERVICES_MORE_OPTIONS_CONSTANTS.VIEW_MANAGE_FEATURES,
        title: i18n.translate(CustomerLocaleKeys.MANAGE_ADD_ONS),
        disabled: true,
        isLocked: true
      }];
      this.moreCellOptionsForRemoved = [{
        id: SERVICES_MORE_OPTIONS_CONSTANTS.VIEW_SERVICE_ATTRIBUTES,
        title: i18n.translate(CustomerLocaleKeys.ORDER_DETAILS.VIEW_SERVICE_ATTRIBUTES)
      }];

      //Service can't be resumed because there is already a future date order to resume the service is in progress
      this.moreCellOptionsForNonBulkSuspendedResumeDisabled = _toConsumableArray(this.moreCellOptionsForNonBulkSuspended);
      this.moreCellOptionsForNonBulkSuspendedResumeDisabledWithManageFeatures = _toConsumableArray(this.moreCellOptionsForNonBulkSuspendedWithManageFeatures);

      //Service can't be suspended because there is already a future date order to suspend the service is in progress
      this.moreCellOptionsForNonBulkActiveLockedSuspendDisabled = _toConsumableArray(this.moreCellOptionsForNonBulkSuspended);
      this.moreCellOptionsForNonBulkActiveLockedSuspendDisabledWithManageFeatures = _toConsumableArray(this.moreCellOptionsForNonBulkSuspendedWithManageFeatures);
      if (this.state.isServiceLifeCycleStatusUpdatable) {
        this.moreCellOptionsForNonBulkActive.push({
          id: SERVICES_MORE_OPTIONS_CONSTANTS.UPDATE_SERVICE_LIFECYCLE_STATUS,
          title: i18n.translate(CustomerLocaleKeys.UPDATE_SERVICE_LIFECYCLE_STATUS)
        });
        this.moreCellOptionsForNonBulkActiveWithManageFeatures.push({
          id: SERVICES_MORE_OPTIONS_CONSTANTS.UPDATE_SERVICE_LIFECYCLE_STATUS,
          title: i18n.translate(CustomerLocaleKeys.UPDATE_SERVICE_LIFECYCLE_STATUS)
        });
      }
      if (this.state.hasSuspendResumeAccess) {
        this.moreCellOptionsForNonBulkActive.push({
          id: SERVICES_MORE_OPTIONS_CONSTANTS.SUSPEND_SERVICE,
          title: i18n.translate(CustomerLocaleKeys.SUSPEND_SERVICE)
        });
        this.moreCellOptionsForNonBulkActiveWithManageFeatures.push({
          id: SERVICES_MORE_OPTIONS_CONSTANTS.SUSPEND_SERVICE,
          title: i18n.translate(CustomerLocaleKeys.SUSPEND_SERVICE)
        });
        this.moreCellOptionsForNonBulkActiveLocked.push({
          id: SERVICES_MORE_OPTIONS_CONSTANTS.SUSPEND_SERVICE,
          title: i18n.translate(CustomerLocaleKeys.SUSPEND_SERVICE),
          disabled: true,
          isLocked: true,
          hasTooltip: true,
          tooltip: {
            context: {
              description: i18n.translate(CustomerLocaleKeys.SUSPENDED_SERVICE_ERROR)
            },
            template: require('./suspend.service.tooltip.html'),
            icon: 'lock'
          }
        });
        this.moreCellOptionsForNonBulkActiveLockedWithManageFeatures.push({
          id: SERVICES_MORE_OPTIONS_CONSTANTS.SUSPEND_SERVICE,
          title: i18n.translate(CustomerLocaleKeys.SUSPEND_SERVICE),
          disabled: true,
          isLocked: true,
          hasTooltip: true,
          tooltip: {
            context: {
              description: i18n.translate(CustomerLocaleKeys.SUSPENDED_SERVICE_ERROR)
            },
            template: require('./suspend.service.tooltip.html'),
            icon: 'lock'
          }
        });
        this.moreCellOptionsForNonBulkSuspended.push({
          id: SERVICES_MORE_OPTIONS_CONSTANTS.RESUME_SERVICE,
          title: i18n.translate(CustomerLocaleKeys.RESUME_SERVICE)
        });
        this.moreCellOptionsForNonBulkSuspendedWithManageFeatures.push({
          id: SERVICES_MORE_OPTIONS_CONSTANTS.RESUME_SERVICE,
          title: i18n.translate(CustomerLocaleKeys.RESUME_SERVICE)
        });
        this.moreCellOptionsForNonBulkSuspendedResumeDisabled.push({
          disabled: true,
          id: SERVICES_MORE_OPTIONS_CONSTANTS.RESUME_SERVICE,
          isLocked: true,
          title: i18n.translate(CustomerLocaleKeys.RESUME_SERVICE)
        });
        this.moreCellOptionsForNonBulkSuspendedResumeDisabledWithManageFeatures.push({
          disabled: true,
          id: SERVICES_MORE_OPTIONS_CONSTANTS.RESUME_SERVICE,
          isLocked: true,
          title: i18n.translate(CustomerLocaleKeys.RESUME_SERVICE)
        });
        this.moreCellOptionsForNonBulkActiveLockedSuspendDisabled.push({
          disabled: true,
          id: SERVICES_MORE_OPTIONS_CONSTANTS.SUSPEND_SERVICE,
          isLocked: true,
          title: i18n.translate(CustomerLocaleKeys.SUSPEND_SERVICE)
        });
        this.moreCellOptionsForNonBulkActiveLockedSuspendDisabledWithManageFeatures.push({
          disabled: true,
          id: SERVICES_MORE_OPTIONS_CONSTANTS.SUSPEND_SERVICE,
          isLocked: true,
          title: i18n.translate(CustomerLocaleKeys.SUSPEND_SERVICE)
        });
      }
      this.moreCellOptionsMap = (_this$moreCellOptions = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_this$moreCellOptions, TYPE_OF_SERVICE.BULK, _toConsumableArray(this.moreCellOptions)), NON_BULK_SERVICE_CATEGORIZATION.ACTIVE_NON_BULK, [].concat(_toConsumableArray(this.moreCellOptionsForNonBulkActive), _toConsumableArray(this.moreCellOptions))), NON_BULK_SERVICE_CATEGORIZATION.ACTIVE_NON_BULK_WITH_MANAGED_FEATURES, [].concat(_toConsumableArray(this.moreCellOptionsForNonBulkActiveWithManageFeatures), _toConsumableArray(this.moreCellOptions))), NON_BULK_SERVICE_CATEGORIZATION.ACTIVE_NON_BULK_SUSPEND_DISABLED, [].concat(_toConsumableArray(this.moreCellOptionsForNonBulkActiveLockedSuspendDisabled), _toConsumableArray(this.moreCellOptions))), NON_BULK_SERVICE_CATEGORIZATION.ACTIVE_NON_BULK_SUSPEND_DISABLED_WITH_MANAGED_FEATURES, [].concat(_toConsumableArray(this.moreCellOptionsForNonBulkActiveLockedSuspendDisabledWithManageFeatures), _toConsumableArray(this.moreCellOptions))), NON_BULK_SERVICE_CATEGORIZATION.SUSPENDED_NON_BULK, [].concat(_toConsumableArray(this.moreCellOptionsForNonBulkSuspended), _toConsumableArray(this.moreCellOptions))), NON_BULK_SERVICE_CATEGORIZATION.SUSPENDED_NON_BULK_WITH_MANAGED_FEATURES, [].concat(_toConsumableArray(this.moreCellOptionsForNonBulkSuspendedWithManageFeatures), _toConsumableArray(this.moreCellOptions))), NON_BULK_SERVICE_CATEGORIZATION.LOCKED_SUSPENDED_NON_BULK_RESUME_DISABLED, [].concat(_toConsumableArray(this.moreCellOptionsForNonBulkSuspendedResumeDisabled), _toConsumableArray(this.moreCellOptions))), NON_BULK_SERVICE_CATEGORIZATION.LOCKED_SUSPENDED_NON_BULK_RESUME_DISABLED_WITH_MANAGED_FEATURES, [].concat(_toConsumableArray(this.moreCellOptionsForNonBulkSuspendedResumeDisabledWithManageFeatures), _toConsumableArray(this.moreCellOptions))), NON_BULK_SERVICE_CATEGORIZATION.LOCKED_SUSPENDED_NON_BULK, [].concat(_toConsumableArray(this.moreCellOptionsForNonBulkActiveLocked), _toConsumableArray(this.moreCellOptions))), _defineProperty(_defineProperty(_this$moreCellOptions, NON_BULK_SERVICE_CATEGORIZATION.LOCKED_SUSPENDED_NON_BULK_WITH_MANAGED_FEATURES, [].concat(_toConsumableArray(this.moreCellOptionsForNonBulkActiveLockedWithManageFeatures), _toConsumableArray(this.moreCellOptions))), NON_BULK_SERVICE_CATEGORIZATION.REMOVED, _toConsumableArray(this.moreCellOptionsForRemoved)));
      this.$scope.datatable = {
        cellTypesOfService: this.cellTypesOfService,
        handleMoreOptionSelected: this.handleMoreOptionSelected,
        moreCellOptionsMap: this.moreCellOptionsMap,
        onViewSelected: this.navigateToView,
        navigateToUsageDetails: this.navigateToUsageDetails,
        navigateToNonTelcoUsageDetails: this.navigateToNonTelcoUsageDetails,
        TYPE_OF_SERVICE: TYPE_OF_SERVICE,
        SERVICE_DETAILS_STATE_NAME: SERVICE_DETAILS_STATE_NAME
      };

      //Sets the name of the UsageCaps Item because it wasn't loaded when the map objects were created.
      Object.keys(this.$scope.datatable.moreCellOptionsMap || {}).forEach(function (el) {
        var usageCapsMenuItemIndex = _this.$scope.datatable.moreCellOptionsMap[el].findIndex(function (cellOption) {
          return cellOption.id === SERVICES_MORE_OPTIONS_CONSTANTS.VIEW_USAGE_CAPS;
        });
        if (usageCapsMenuItemIndex > -1) {
          _this.$scope.datatable.moreCellOptionsMap[el][usageCapsMenuItemIndex].title = i18n.translate(CustomerLocaleKeys.USAGE_CAP_SETTINGS);
        }
      });
      if (!this.state.isServiceReasonCodeLoaded) {
        this.actions.fetchCodeTypesThunk(CODES.ReasonCodes);
      }
      if (!this.state.isUnitOfMeasurementLoaded) {
        this.actions.fetchCodeTypesThunk(CODES.UnitsOfMeasure);
      }
      this.isDataLoading = function () {
        return _this.state.isFetchingBulkServices;
      };
      this.attributeModalConfig = {
        onRegisterApi: function onRegisterApi(event) {
          _this.attributeModalAPI = event.api;
        }
      };
      this.updateServiceLifeCycleStatusConfig = {
        onRegisterApi: function onRegisterApi(event) {
          _this.updateServiceLifeCycleStatusModalAPI = event.api;
        }
      };
      if (!this.state.serviceAttributesLoaded) {
        this.actions.fetchServiceAttributes();
      }
      if (!this.state.regexCodesLoaded) {
        this.actions.fetchRegexCodes();
      }
      if (!this.state.isServiceLifeCycleStatusLoaded) {
        this.actions.fetchCodeTypesThunk(CODES.ServiceLifeCycleStatus).then(function () {
          //Sets the update lifecycle status option because it wasn't loaded when the map objects were created.
          if (_this.state.isServiceLifeCycleStatusUpdatable) {
            _this.$scope.datatable.moreCellOptionsMap[NON_BULK_SERVICE_CATEGORIZATION.ACTIVE_NON_BULK].push({
              id: SERVICES_MORE_OPTIONS_CONSTANTS.UPDATE_SERVICE_LIFECYCLE_STATUS,
              title: i18n.translate(CustomerLocaleKeys.UPDATE_SERVICE_LIFECYCLE_STATUS)
            });
            _this.$scope.datatable.moreCellOptionsMap[NON_BULK_SERVICE_CATEGORIZATION.ACTIVE_NON_BULK_WITH_MANAGED_FEATURES].push({
              id: SERVICES_MORE_OPTIONS_CONSTANTS.UPDATE_SERVICE_LIFECYCLE_STATUS,
              title: i18n.translate(CustomerLocaleKeys.UPDATE_SERVICE_LIFECYCLE_STATUS)
            });
          }
        });
      }
      this.handleStatusFilter = function (selected) {
        _this.actions.setBulkServicesStatusFilter(selected);
        _this.onPageSelected(DEFAULT_PAGE_NUMBER);
      };
      this.onPageSelected(DEFAULT_PAGE_NUMBER);
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnect();
    }
  }, {
    key: "closeAttributeModal",
    value: function closeAttributeModal() {
      this.attributeModalAPI.close();
      this.showAttributeModal = false;
    }
  }, {
    key: "onCloseUpdateServiceLifeCycleStatusModal",
    value: function onCloseUpdateServiceLifeCycleStatusModal() {
      this.showUpdateServiceLifeCycleStatusModal = false;
      this.updateServiceLifeCycleStatusModalAPI.close();
    }
  }, {
    key: "openServiceAttributes",
    value: function openServiceAttributes(item) {
      this.editAttributes = Immutable([]);
      var attributes = this.state.bulkServices.serviceThumbnails.find(function (thumbnail) {
        return thumbnail.ServiceIdentifier === item.ServiceIdentifier.Value;
      });
      this.availableAttributes = Immutable(attributes ? attributes.ServiceAttributeValues : []);
      this.attributeModalContentTitle = i18n.translate(CustomerLocaleKeys.ORDER_DETAILS.SERVICE_ATTRIBUTES.TITLE);
      this.showAttributeModal = true;
      this.$timeout(this.attributeModalAPI.open);
    }
  }, {
    key: "openUpdateServiceLifeCycleStatus",
    value: function openUpdateServiceLifeCycleStatus(item) {
      this.ServiceIdentifier = item.ServiceIdentifier.Value;
      this.showUpdateServiceLifeCycleStatusModal = true;
      this.$timeout(this.updateServiceLifeCycleStatusModalAPI.open);
    }
  }, {
    key: "pageSizeOptionSelected",
    value: function pageSizeOptionSelected(pageSize) {
      this.actions.setBulkServicesPageSize(pageSize);
      this.onPageSelected(DEFAULT_PAGE_NUMBER);
    }
  }, {
    key: "onPageSelected",
    value: function onPageSelected(pageNumber) {
      var _this2 = this;
      if (!this.state.pageSize) {
        this.actions.setBulkServicesPageSize(this.state.userPageSizePreference);
      }
      this.actions.setCurrentPage(pageNumber);
      var params = Object.assign({}, this.state.routeParams, {
        pageNumber: pageNumber
      });
      params.status = this.state.selectedStatusFilter ? this.state.selectedStatusFilter.value : null;
      params.serviceType = this.state.selectedTypeOfServiceFilter ? this.state.selectedTypeOfServiceFilter.value : null;
      params.searchIdentifier = this.state.searchString;
      params.pageSize = this.state.pageSize;
      this.actions.searchServices(params, {
        pageNumber: pageNumber
      }).then(function () {
        _this2.searchOpenOrders().then(function () {
          _this2.actions.retrieveConvergentBillerAccountDetails(_this2.state.currentCustomerId);
        }).catch(function (error) {
          _this2.uiNotificationService.transientError(error.translatedMessage);
        });
      });
    }
  }, {
    key: "handleExpansion",
    value: function handleExpansion(item) {
      item.isExpanded = !item.isExpanded;
    }
  }, {
    key: "searchChanged",
    value: function searchChanged(searchText) {
      this.actions.setBulkServicesSearchString(searchText);
      this.onPageSelected(DEFAULT_PAGE_NUMBER);
    }
  }, {
    key: "handleTypeOfServiceFilter",
    value: function handleTypeOfServiceFilter(selected) {
      this.actions.setServicesTypeOfServiceFilter(selected);
      this.onPageSelected(DEFAULT_PAGE_NUMBER);
    }
  }, {
    key: "servicesGridSetup",
    value: function servicesGridSetup() {
      return {
        columnDefs: createTableServicesListHeaders(),
        data: this.state.tableData
      };
    }
  }, {
    key: "onApiError",
    value: function onApiError(error) {
      this.uiNotificationService.transientError(error.translatedMessage);
    }
  }, {
    key: "searchOpenOrders",
    value: function searchOpenOrders() {
      var filters = {
        Statuses: [ORDER_STATUS.OPEN],
        Types: [ORDER_TYPES.RESTORE, ORDER_TYPES.SUSPEND]
      };
      return this.actions.searchOrders(this.state.currentCustomerId, filters);
    }
  }]);
}();
export default {
  bindings: {
    onOpenSuspendService: '&'
  },
  controller: ServicesListController,
  template: require('./services.list.html')
};